import { VoidCanvas } from "./canvas/VoidCanvas";
import { Overlay } from "./ui/Overlay";
import "./audio-future.css";
import "./overlay.css";

export function App() {
  return (
    <div className="app">
      <VoidCanvas />
      <Overlay />
    </div>
  );
}
